export { default } from './Ratios';
